import type { FC, ReactNode } from 'react';

import { Typography } from 'enable-ui';

export const SubTitle: FC<{ leftTitle: ReactNode; rightTitle: ReactNode }> = ({
  leftTitle,
  rightTitle,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <Typography
        style={{
          textAlign: 'start',
          fontSize: '14px',
          lineHeight: '20px',
          color: '#808080',
        }}
      >
        {leftTitle}
      </Typography>
      <span style={{ color: '#808080' }}>&#8226; </span>
      <Typography style={{ fontSize: '14px', lineHeight: '20px', color: '#808080' }}>
        {rightTitle}
      </Typography>
    </div>
  );
};
